import { string as YupString, ValidationError } from 'yup';
/* Auth0 uses validator.js isEmail to valide email
 * so front-end validation must follow
 */
import _isEmail from 'validator/lib/isEmail';

/* extra guard as validator.js isEmail method
 * does not allow undefined values */
const isEmail = (value) => value && _isEmail(value);

// Do not check strictly if mobile is going through verification
export const verifiedMobileRegex = new RegExp(/^[89]\d{7}$/i);

export default {
  nameValidation: ({ emptyNameMsg, invalidNameMsg, maxLengthMessage }) =>
    YupString()
      .trim()
      .required(emptyNameMsg)
      .max(40, maxLengthMessage)
      .matches(
        /* eslint-disable */
        new RegExp(/^[A-z\xc0-\xff]+(?:(?:[A-z\xc0-\xff\d ',\.\-\/])?)+$/i),
        /* eslint-disable */
        { message: invalidNameMsg, excludeEmptyString: true },
      ),

  newPasswordValidation: ({ minLengthMessage, minOneNumberMessage, minOneLetterMessage }) =>
    YupString()
      .trim()
      .min(8, minLengthMessage)
      .matches(new RegExp(/\d+/i), minOneNumberMessage)
      .matches(new RegExp(/[A-z]+/i), minOneLetterMessage)
      .strict(true),

  emailValidation: ({ emptyEmailMessage, invalidEmailMessage, maxLengthMessage }) =>
    YupString()
      .trim()
      .required(emptyEmailMessage)
      .max(64, maxLengthMessage)
      .test('email-validation-auth0', invalidEmailMessage, (value) => isEmail(value)),

  contactNumberValidation: ({ invalidContactNumberMessage }) =>
    YupString().trim().matches(verifiedMobileRegex, invalidContactNumberMessage),

  emailOrPhoneValidation: ({ emptyValueMessage, invalidValueMessage, maxLengthMessage }, path) =>
    YupString()
      .trim()
      .required(emptyValueMessage)
      .test('email-or-phone-validation', invalidValueMessage, (value) => {
        // email
        if (isEmail(value)) {
          if (value.length > 64) {
            return new ValidationError(maxLengthMessage, value, path);
          }
          return true;
        }

        // phone
        if (verifiedMobileRegex.test(value)) {
          return true;
        }

        return false;
      }),
};
